export const News = 'News/';

export const GetNews = News + 'GetAll';
